<div class="unauthenticated">

  <div class="main-panel">

    <div class="container">

      <div class="row">

        <div class="col-md-6 mb-5">
          <div class="row">
          <div class="login-message">
            <div class="row" style=" justify-content: center; align-items: center;">
              <div class="col-md-7">
                <h3>Bienvenido a Mi Ahorro</h3>
              </div>
              <div class="col-md-2" >
                <img class="akibaLogo" src="assets/img/miahorro.svg">
              </div>
              <div class="col-md-1">
              </div>
            </div>

            <div class="mt-4 text-center">
              <div class="row" style="justify-content: center;">
                <div class="col-md-10">
                  <h4>Si <b>NO</b> recuerdas tu fecha de ingreso</h4>
                  <p>acércate con tu supervisor directo para obtener el dato</p>
                </div>
            </div>
          </div>

          </div>
          </div>

        </div>

        <div class="col-md-1"></div>

        <div class="col-md-5">

          <div class="card card-signup">

            <div class="header text-center" data-background-color="rose">
              <h2>Mi Ahorro</h2>
            </div>

            <p class="text-divider">Ingresa usando tu usuario y contraseña</p>

            <div class="content">

              <div class="row px-2">

                <div class="col-md-2">
                  <mat-icon matSuffix>person</mat-icon>
                </div>

                <div class="col-md-10">
                  <mat-form-field>
                    <input matInput placeholder="Ingresa tu número de Colaborador" [(ngModel)]="model.employeeNumber"
                      #employeeNumber="ngModel" type="text" name="employeeNumber" required>
                    <mat-error *ngIf="employeeNumber?.errors?.required">Es necesario que ingreses tu número de
                      Colaborador</mat-error>
                  </mat-form-field>
                </div>

              </div>

              <div class="text-center my-2">y</div>

              <div class="row px-2">

                <div class="col-md-2">
                  <mat-icon matSuffix>email</mat-icon>
                </div>

                <div class="col-md-10">
                  <mat-form-field>
                    <input matInput [matDatepicker]="exceptionPicker" placeholder="Mes y Año De Ingreso A Bimbo" [(ngModel)]="seniorityDate" readonly required>
                    <mat-datepicker-toggle matSuffix [for]="exceptionPicker"></mat-datepicker-toggle>
                    <mat-datepicker #exceptionPicker 
                    disabled="false" 
                    startView="multi-year" 
                    (yearSelected)="chosenYearHandler($event)"
                    (monthSelected)="chosenMonthHandler($event, exceptionPicker)"></mat-datepicker>
                  </mat-form-field>
                </div>

              </div>

              <mat-divider class="my-4 mx-4"></mat-divider>

              <div class="row px-2">

                <div class="col-md-2">
                  <mat-icon matSuffix>lock</mat-icon>
                </div>

                <div class="col-md-10">
                  <mat-form-field>
                    <input matInput placeholder="Ingresa Nueva Contraseña" [(ngModel)]="model.password" #password="ngModel"
                      type="password" name="password" required>
                    <mat-error *ngIf="password?.errors?.required">Es necesario que ingreses tu contraseña</mat-error>
                  </mat-form-field>
                </div>

              </div>

              <div class="row px-2">

                <div class="col-md-2">
                  <mat-icon matSuffix>lock</mat-icon>
                </div>

                <div class="col-md-10">
                  <mat-form-field>
                    <input matInput placeholder="Confirma La Contraseña" [(ngModel)]="model.passwordConf" #passwordConf="ngModel"
                      type="password" name="passwordConf" required>
                    <mat-error *ngIf="passwordConf?.errors?.required">Es necesario que ingreses tu contraseña</mat-error>
                  </mat-form-field>
                </div>

              </div>

              <div class="row my-4">
                <div class="col-md-12">
                  <button class="btn btn-block btn-primary" (click)="onEnter()">establecer</button>
                </div>
              </div>

            </div>

          </div>

        </div>

      </div>

    </div>

  </div>

</div>